export default function Reducer(state, action) {
  switch (action.type) {
    case 'CURRENCY':
      return {
        ...state,
        currency: action.currency,
      };
    case 'LOAD':
      return {
        ...state,
        plans: action.plans,
      };

    case 'LOAD_ENTERPRISE':
      return {
        ...state,
        enterprise: action.enterprise,
      };

    case 'DELETE':
      return {
        ...state,
        plans: state.plans.filter((item) => item.id !== action.planId),
      };

    default:
      throw Error(`Unknown action: ${action.type}`);
  }
}
